import type { WorkspaceColorScheme } from '@/features/iam/workspaces/workspace-branding'
import type { Theme } from '@/features/shell/theming'
import { darken } from '@/utils/color-util'

/**
 * Gets the theme based on the selected workspace branding settings.
 *
 * @param workspaceColors
 */
export function getThemeFromWorkspaceColors(
  workspaceColors: WorkspaceColorScheme,
): Theme {
  const brand = workspaceColors.primary

  // Fall back to the light mode brand color.
  const brandDark = workspaceColors.primaryDark || brand

  // Special value for the default theme, otherwise just darken the
  // primary color.
  const accent = brand === '#0088ff' ? '#004fb6' : darken(brand, 20)

  // Same darkening trick for the dark mode accent, but only
  // if the dark mode variant was actually set, otherwise we'll
  // just use whatever was calculated for the light mode accent since
  // it would be the same.
  const accentDark = brandDark ? darken(brandDark, 20) : accent

  return {
    brand,
    brandDark,
    accent,
    accentDark,
  }
}
